import { FeedbackModal } from "@/components/modals/feedback-modal/feedback-modal";
import { UnlockAppModal } from "@/components/modals/feedback-modal/unlock-app";
import { ActorDeleteModal } from "@/features/data-manager/modals/actor-delete";
import { AddNewDatasetModal } from "@/features/data-manager/modals/add-dataset";
import CancelExportModal from "@/features/data-manager/modals/cancel-export";
import CancelUploadModal from "@/features/data-manager/modals/cancel-upload";
import { DatasetDetailModal } from "@/features/data-manager/modals/dataset-details/dataset-detail";
import DeleteIoRecordConfirmationModal from "@/features/data-manager/modals/delete-confirmation";
import DiscardDatasetModal from "@/features/data-manager/modals/discard-dataset";
import { DownloadDatasetModal } from "@/features/data-manager/modals/download-dataset";
import { EditDatasetDetail } from "@/features/data-manager/modals/edit-dataset.tsx/edit-dataset-detail";
import { ExportConnectorsModal } from "@/features/data-manager/modals/export-connectors/export-connectors";
import { ExportDataset } from "@/features/data-manager/modals/export-dataset";
import ExportErrorModal from "@/features/data-manager/modals/export-error";
import IoRecordError from "@/features/data-manager/modals/iorecord-errors";
import { SelectSheetModal } from "@/features/data-manager/modals/select-sheet";
import UsageConfirmationModal from "@/features/data-manager/modals/usage-confirmation";
import {
  DeleteStepConfirmation,
  ErrorModal,
  FatalErrorModal,
  SaveStep,
  ShowFullValueModal,
  TerminateExecutionConfirmation,
} from "@/features/data-transformation/modals";
import { CloseEdaDiscardChanges } from "@/features/data-transformation/modals/close-eda.tsx";
import { EDASessionEnded } from "@/features/data-transformation/modals/eda-timeout/session-ended";
import { EDASessionTimeoutWarningModal } from "@/features/data-transformation/modals/eda-timeout/session-timeout-warning";
import { ExecutionRequired } from "@/features/data-transformation/modals/execution-required";
import { ExploreDataModal } from "@/features/data-transformation/modals/explore-data";
import ExpandedPromptModal from "@/features/llm-prompt/modals/expanded-prompt";
import LLMErrorsModal from "@/features/llm-prompt/modals/llm-errors";
import { AddAdminModal } from "@/features/org-settings/modals/add-admin/add-admin";
import AdminWarningModal from "@/features/org-settings/modals/admin-warning";
import { InviteMembersModal } from "@/features/org-settings/modals/invite-members/invite-members.tsx";
import RemoveConfirmation from "@/features/org-settings/modals/remove-confirmation";
import RemoveOrgUserConfirmation from "@/features/org-settings/modals/remove-org-user";
import DeleteAccountModal from "@/features/user-manager/modals/delete-account";
import DeleteOTPModal from "@/features/user-manager/modals/delete-otp";
import { InviteMemberManageAccess } from "@/features/user-manager/modals/invite-users";
import LeaveOrgModal from "@/features/user-manager/modals/leave-org";
import ManageAccessModal from "@/features/user-manager/modals/manage-access";
import RemoveUserAccess from "@/features/user-manager/modals/remove-access-confirmation";
import { WfConfirmationModal } from "@/features/workflow-studio/modals/confimation";
import { ConfirmEdgeDelete } from "@/features/workflow-studio/modals/confirm-edge-delete";
import { ConfirmNodeDelete } from "@/features/workflow-studio/modals/confirm-node-delete";
import { ConfirmNodeEdit } from "@/features/workflow-studio/modals/confirm-node-edit";
import ConfirmTerminateModal from "@/features/workflow-studio/modals/confirm-terminate";
import EditFlowDetailsModal from "@/features/workflow-studio/modals/edit-flow-details";
import FlowDetailModal from "@/features/workflow-studio/modals/flow-detail-preview";
import FlowPreviewModal from "@/features/workflow-studio/modals/flow-preview";
import MarkAsOutputModal from "@/features/workflow-studio/modals/mark-as-output";
import RenameNodeModal from "@/features/workflow-studio/modals/rename-node";
import RunErrorsModal from "@/features/workflow-studio/modals/run-errors";
import WorkflowErrorsModal from "@/features/workflow-studio/modals/run-workflow";
import { TimedOutModal } from "@/features/workflow-studio/modals/timeout-modals/timed-out";
import { TimeoutWarningModal } from "@/features/workflow-studio/modals/timeout-modals/timeout-warning";
import UploadToFlowStoreModal from "@/features/workflow-studio/modals/upload-flow";
import RenameVersionModal from "@/features/workflow-studio/modals/version-history";
import ConfirmationModal from "@/features/ws-manager/modals/confirmation-modal.tsx";
import CreateAnalysisModal from "@/features/ws-manager/modals/create-analysis";
import CreateProjectModal from "@/features/ws-manager/modals/create-project";
import WorkspaceCreationModal from "@/features/ws-manager/modals/create-workspace";
import { InfoModal } from "@/features/ws-manager/modals/info-modal.tsx";
import MoveAnalysisModal from "@/features/ws-manager/modals/move-analysis-modal.tsx";
import MoveProjectModal from "@/features/ws-manager/modals/move-project-modal.tsx";
import { ProfileSettings } from "@/features/ws-manager/modals/profile";

import { ModalTypes } from "./modals-constant";


export const MODAL_COMPONENTS = {
  [ModalTypes.CONFIRMATION]: ConfirmationModal,
  [ModalTypes.WORKSPACE_CREATION]: WorkspaceCreationModal,
  [ModalTypes.PROJECT_CREATION]: CreateProjectModal,
  [ModalTypes.ANALYSIS_CREATION]: CreateAnalysisModal,
  [ModalTypes.INFO]: InfoModal,
  [ModalTypes.PROFILE]: ProfileSettings,
  [ModalTypes.ADD_NEW_DATASET]: AddNewDatasetModal,
  [ModalTypes.DELETE_IO_RECORD]: DeleteIoRecordConfirmationModal,
  [ModalTypes.IORECORD_ERRORS]: IoRecordError,
  [ModalTypes.MOVE_ANALYSIS]: MoveAnalysisModal,
  [ModalTypes.MOVE_PROJECT]: MoveProjectModal,

  // Workflow Modals
  [ModalTypes.WORKFLOW_ERRORS]: WorkflowErrorsModal,
  [ModalTypes.EDIT_FLOW_DETAILS]: EditFlowDetailsModal,
  [ModalTypes.UPLOAD_FLOW]: UploadToFlowStoreModal,
  [ModalTypes.MARK_AS_OUTPUT]: MarkAsOutputModal,
  [ModalTypes.FLOW_PREVIEW]: FlowPreviewModal,
  [ModalTypes.FLOW_DETAILS]: FlowDetailModal,
  [ModalTypes.RENAME_NODE]: RenameNodeModal,
  [ModalTypes.CONFIRM_TERMINATE]: ConfirmTerminateModal,
  [ModalTypes.DELETE_NODE]: ConfirmNodeDelete,
  [ModalTypes.DELETE_EDGE]: ConfirmEdgeDelete,
  [ModalTypes.CONFIRM_NODE_EDIT]: ConfirmNodeEdit,
  [ModalTypes.RUN_ERRORS]: RunErrorsModal,
  [ModalTypes.WF_CONFIRMATION]: WfConfirmationModal,
  [ModalTypes.RENAME_VERSION]: RenameVersionModal,
  //EDA modals
  [ModalTypes.EXPLORE_DATASET]: ExploreDataModal,
  [ModalTypes.FULL_DATA]: ShowFullValueModal,
  [ModalTypes.SAVE_STEPS]: SaveStep,
  [ModalTypes.DELETE_STEP]: DeleteStepConfirmation,
  [ModalTypes.ERROR_STEPS_WARNING]: ErrorModal,
  [ModalTypes.EXECUTION_REQUIRED]: ExecutionRequired,
  [ModalTypes.TERMINATE_EXECUTION]: TerminateExecutionConfirmation,
  [ModalTypes.CLOSE_EDA]: CloseEdaDiscardChanges,
  [ModalTypes.FATAL_ERROR]: FatalErrorModal,
  [ModalTypes.EDA_SESSION_TIMEOUT_WARNING]: EDASessionTimeoutWarningModal,
  [ModalTypes.EDA_SESSION_ENDED]: EDASessionEnded,

  // usermanager modals
  [ModalTypes.MANAGE_ACCESS]: ManageAccessModal,
  [ModalTypes.INVITE_USERS]: InviteMembersModal,
  [ModalTypes.ADD_ADMIN]: AddAdminModal,
  [ModalTypes.REMOVE_ADMIN]: RemoveConfirmation,
  [ModalTypes.REMOVE_ORG_USER]: RemoveOrgUserConfirmation,
  [ModalTypes.WARNING_ADMIN]: AdminWarningModal,
  [ModalTypes.REMOVE_USER_ACCESS]: RemoveUserAccess,
  [ModalTypes.INVITE_MEMBER_MANAGE_ACCESS]: InviteMemberManageAccess,
  [ModalTypes.LEAVE_ORG]: LeaveOrgModal,
  [ModalTypes.DELETE_ACCOUNT]: DeleteAccountModal,
  [ModalTypes.DELETE_OTP]: DeleteOTPModal,

  // LLM Modals
  [ModalTypes.LLM_ERRORS]: LLMErrorsModal,
  [ModalTypes.EXPANDED_PROMPT]: ExpandedPromptModal,

  //DATA Manager
  [ModalTypes.EXPORT_DATASET]: ExportDataset,
  [ModalTypes.CANCEL_UPLOAD]: CancelUploadModal,
  [ModalTypes.SELECT_SHEET]: SelectSheetModal,
  [ModalTypes.DOWNLOAD_DATA]: DownloadDatasetModal,
  [ModalTypes.DATASET_NAME]: DatasetDetailModal,
  [ModalTypes.DISCARD_DATASET]: DiscardDatasetModal,
  [ModalTypes.USAGE_CONFIRMATION]: UsageConfirmationModal,
  [ModalTypes.EDIT_DATASET_DETAILS]: EditDatasetDetail,
  [ModalTypes.EXPORT_CONNECTORS]: ExportConnectorsModal,
  [ModalTypes.EXPORT_ERROR]: ExportErrorModal,
  [ModalTypes.CANCEL_EXPORT]: CancelExportModal,
  [ModalTypes.DELETE_ACTOR]: ActorDeleteModal,

  // Timeout Modals
  [ModalTypes.TIMEOUT_WARNING]: TimeoutWarningModal,
  [ModalTypes.TIMED_OUT]: TimedOutModal,

  [ModalTypes.FEEDBACK]: FeedbackModal,
  [ModalTypes.UNLOCK_APP]: UnlockAppModal,
};
